export const ORGANISATIONS_INPUT = 'ORGANISATIONS_INPUT' as const;
export const ORGANISATIONS_OUTPUT = 'ORGANISATIONS_OUTPUT' as const;
